import { Skeleton } from 'antd';

const Loading = () => {
  return (
    <div className="skeleton_listing">
      <Skeleton />
    </div>
  );
};

export default Loading;
